import { z } from "zod";
import { Color, Colors } from "./colors";
// Base configuration defaults
export const BaseOverlayDefaultConfig = {
    debugMode: false,
    demoMode: false,
    showAllDonations: false,
};
export const BaseProgressBarDefaultConfig = {
    backgroundColor: Color.DEFAULT_RED,
    ccam: false,
    showAllDonations: false,
    showChallenges: true,
    showDonors: true,
    showRewards: true,
    showScroller: true,
};
export const BaseOverlayConfig = z.object({
    debugMode: z.boolean().default(BaseOverlayDefaultConfig.debugMode).optional(),
    demoMode: z.boolean().default(BaseOverlayDefaultConfig.demoMode).optional(),
    hideShowTimer: z.coerce.number().optional().nullish(),
    showAllDonations: z
        .boolean()
        .default(BaseOverlayDefaultConfig.showAllDonations)
        .optional(),
});
export const BaseProgressBarConfig = BaseOverlayConfig.extend({
    backgroundColor: Colors.default(BaseProgressBarDefaultConfig.backgroundColor).optional(),
    ccam: z.coerce.boolean().nullish().optional(),
    donationTimeOffset: z.coerce.number().int().min(-1).optional().nullish(),
    showChallenges: z.coerce
        .boolean()
        .default(BaseProgressBarDefaultConfig.showChallenges)
        .optional(),
    showDonors: z.coerce
        .boolean()
        .default(BaseProgressBarDefaultConfig.showDonors)
        .optional(),
    showRewards: z.coerce
        .boolean()
        .default(BaseProgressBarDefaultConfig.showRewards)
        .optional(),
    showScroller: z.coerce.boolean().optional().nullish(),
});
//# sourceMappingURL=config.js.map